import axios from 'axios'
const url = '/contabilidad/plancuentas'

export default {
    indexLineas() {
        return axios.get('/contabilidad/lineas');
    },
    indexLineasCategorias() {
        return axios.get('/contabilidad/lineas/categorias');
    },
    createLinea(data) {
        return axios.post('/contabilidad/lineas', data);
    },
    asignarLinea(categoria, linea) {
        return axios.post('/contabilidad/lineas/asignar', { categoria, linea });
    },
    registrarSucursalContable(sucursal_uuid) {
        return axios.post('/contabilidad/sucursal', { sucursal_uuid });
    },
    create(data) {
        return axios.post(url, data)
    },
    update(data) {
        return axios.put(`${url}/${data.id}`, data)
    },
    async indexPlanCuentas(params = {}) {
        return axios.get(url, { params }); // Enviar parámetros dinámicos
    },
    registrarPlanDeCuentas(empresaUuid) {
        return axios.post('/contabilidad/procesarcuentas', { empresa_uuid: empresaUuid });
    },

    delete(data) {

        return axios.delete(`${url}/${data.id}`)

    },
    indexRubroVentas(sucursal_uuid) {
        let url = '/contabilidad/rubroventa';
        if (sucursal_uuid) {
            url += `?sucursal_uuid=${sucursal_uuid}`;
        }
        return axios.get(url);
    },
    


    createRubroVenta(data) {
        const url = '/contabilidad/rubroventa'
        return axios.post(url, data)
    },

    updateRubroVenta(data) {
        const url = '/contabilidad/rubroventa'
        return axios.put(`${url}/${data.id}`, data)

    },

    deleteRubro(data) {
        const url = '/contabilidad/rubroventa'

        return axios.delete(`${url}/${data.id}`)
    },

    indexRubroCompras(sucursal_uuid) {
        let url = '/contabilidad/rubrocompra';
        if (sucursal_uuid) {
            url += `?sucursal_uuid=${sucursal_uuid}`;
        }
        return axios.get(url);
    },


    createRubroCompra(data) {
        const url = '/contabilidad/rubrocompra'
        return axios.post(url, data)
    },

    updateRubroCompra(data) {
        const url = '/contabilidad/rubrocompra'
        return axios.put(`${url}/${data.id}`, data)

    },

    deleteRubroCompra(data) {
        const url = '/contabilidad/rubrocompra'

        return axios.delete(`${url}/${data.id}`)
    },


    show(id) {
        return axios.get(`${url}/${id}`)
    },

    getAlertasPSP(sucursal_uuid) {
        const params = sucursal_uuid ? { sucursal_uuid } : {};
        return axios.get('/contabilidad/alertas/psp', { params });
    },

    getConfiguracionStatus(sucursal_uuid) {
        const params = sucursal_uuid ? { sucursal_uuid } : {};
        return axios.get('/contabilidad/configuracion-status', { params });
    },

}